import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import { GET_COMPANY_METADATA_API_TAG } from '@epi-api/apiTags';
import { ICompanyMetadata } from '@epi-models/core/Layout';

import config from '../../config/config';

export const getCompanyMetadata = async (): Promise<ICompanyMetadata> =>
  get<ICompanyMetadata>(`${config.apiHost}/api/company-metadata`);

export const companyMetadataApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getMetadata: build.query<ICompanyMetadata, void>({
      async queryFn(_arg, api) {
        try {
          const data = await getCompanyMetadata();
          return { data };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 1800,
      providesTags: [GET_COMPANY_METADATA_API_TAG]
    })
  })
});

export const { useGetMetadataQuery } = companyMetadataApi;
